import PropTypes from "prop-types";
import cn from "classnames";
import Container from "components/adventure/Container";
import Text from "components/adventure/Text";
import styles from "components/adventure/Testimonial.module.scss";

export default function Testimonial({ text, byline = "", theme }) {
  return (
    <div className={cn(styles.component, styles[`theme-${theme}`])}>
      <Container className={styles.container}>
        <div className={styles.text}>&ldquo;{text}&rdquo;</div>
        <Text className={styles.byline}>—{byline}</Text>
      </Container>
    </div>
  );
}

Testimonial.propTypes = {
  text: PropTypes.string.isRequired,
  byline: PropTypes.string.isRequired,
  theme: PropTypes.string.isRequired,
};
